export const makeSelectables = (selectedIds, allItems) => {

    let allSelected = selectedIds.includes('-1');

    let selectedById = {};
    if (!allSelected) {
        selectedIds.forEach(id => selectedById[id] = true)
    }

    return {
        all: () => allItems,

        getSelectedIds: () =>
            allSelected ? ['-1'] : Object.keys(selectedById).filter(id => selectedById[id]),

        getSelectedNames: () =>
            allItems.filter(({id}) => selectedById[id]).map(g => g.name).join(','),

        isAllSelected: () => allSelected,

        isSelected: id => allSelected || !!selectedById[id],

        toggle: id => {
            if (allSelected) {
                allItems.forEach(({id}) => selectedById[id] = true);
                allSelected = false;
            }
            selectedById[id] = !selectedById[id];
        },

        toggleAll: () => {
            allSelected = !allSelected;
            selectedById = {};
        },
    };
};



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/make-selectables.js